export function encodeValue(val: string): string {
	return val
		.replace(/([a-z])([A-Z])/g, "$1_$2") // Convert camelCase to snake_case
		.toLowerCase() // Convert to lowercase
		.replace(/[\s\-]+/g, "_"); // Replace spaces and hyphens with _
}

export function decodeValue(val: string): string {
	return val
		.toLowerCase() // Ensure consistent casing
		.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase()); // Convert _x to X
}

export function encodeMaxAgeAndPossession(val: string): string {
	return val.replace(/:/g, "_");
}

export function decodeMaxAgeAndPossession(val: string): string {
	return val.replace(/_/g, ":");
}
